/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import ShareCardSummaryCategoryTitle from './ShareCardSummaryCategoryTitle';
import ShareCardSummaryGroup from './ShareCardSummaryGroup';

import ShareCardIncludedTypeNames from '../../../../constants/ShareCardIncludedTypeNames';
import ShareCardModel from '../../../../models/ShareCardModel';
import { ShareCardSummaryNoteListItem } from '../../../components/NoteListItem';
import NoteModel from '../../../../models/NoteModel';

import ShareCardSummaryList from './ShareCardSummaryList';

interface Props {
  shareCard: ShareCardModel;
  newerCollection: NoteModel[];
  languageCode: string;
}

const ShareCardSummaryNotes = (props: Props) => {
  const newerEntries = props.newerCollection.filter((f) => {
    return props.shareCard.note.isIncluded(f.data.id);
  });

  if (newerEntries.length === 0) { return null; }

  return (
    <ShareCardSummaryGroup>
      <ShareCardSummaryCategoryTitle categoryName="notes" includedValues={ShareCardIncludedTypeNames.latest} />

      <ShareCardSummaryList
        items={newerEntries}
        renderItem={(note: NoteModel) => (
          <ShareCardSummaryNoteListItem note={note} languageCode={props.languageCode} />
        )}
      />
    </ShareCardSummaryGroup>
  );
};

export default ShareCardSummaryNotes;
